import { useCallback } from "react";

import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { SEARCH_INTENT_PROJECTS } from "../useSearchIntentProjects/gql";
import { UPDATE_INTENT_PROJECT } from "./gql";
import { GET_INTENT_PROJECT } from "../useIntentProject/gql";
import { GET_INTENT_PROJECT_POLICIES } from "../useIntentProjectPolicies/gql";

type UpdateIntentProjectInput = {
  id: string;
  name?: string;
  description?: string;
  space?: string;
  labels?: string[];
  workerPool?: string;
  runnerImage?: string;
};

const updateIntentProjectHook = createDefaultMutationHook(UPDATE_INTENT_PROJECT);

const useUpdateIntentProject = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [updateMutation, { loading, error }] = updateIntentProjectHook({
    refetchQueries: [SEARCH_INTENT_PROJECTS, GET_INTENT_PROJECT, GET_INTENT_PROJECT_POLICIES],
  });

  const updateIntentProject = useCallback(
    (input: UpdateIntentProjectInput, callback?: () => void) => {
      updateMutation(
        {
          id: input.id,
          name: input.name || null,
          description: input.description || null,
          space: input.space || null,
          labels: input.labels ?? null,
          workerPool: input.workerPool ?? null,
          runnerImage: input.runnerImage ?? null,
        },
        (data) => {
          if (data?.intentProjectUpdate.id) {
            reportSuccess({ message: "Intent Project updated successfully" });
            callback?.();
          }
        }
      );
    },
    [updateMutation, reportSuccess]
  );

  return {
    updateIntentProject,
    loading,
    error,
  };
};

export default useUpdateIntentProject;
